import React, { useEffect } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  HStack,
  useColorModeValue as mode,
  Avatar,
  Text,
} from "@chakra-ui/react";
import { useRouter } from "next/router";

// Components
import Posts from "./Posts";
import ProfileTab from "./ProfileTab";

const Profiles = ({ account, session, selectedTabIdx, setSelectedTabIdx, onRemoving, onSessionUpdate }) => {
  const router = useRouter();
  useEffect(() => {
    const url = new URL(window.location.href);
    const tab = url.searchParams.get("profile");
    if (tab) {
      const idx = account?.mentionsProfiles?.findIndex((profile) => profile.username === tab);
      if (idx !== -1) {
        setSelectedTabIdx(idx + 1);
      }
    }
  }, [router.asPath]);

  // Get profiles
  return (
    <Tabs isLazy
      onChange={(index) => {
        setSelectedTabIdx(index);
        // router.push(`/mentions?profile=${profiles[index].username}}`);

        router.push({
          pathname: router.pathname,
          query: { profile: index === 0 ? account.username : account.mentionsProfiles[index - 1].username },
        });
      }}
      index={selectedTabIdx}
    >
      <TabList mb={4}>
        <Tab
          key={account.id}
          py={2}
          px={4}
        >
          <HStack spacing={2}>
            <Avatar name={account.name} src={account.image || account.imageHosted} size="xs" />
            <Text as="span" fontWeight="semibold">{account.name}</Text>

          </HStack>
        </Tab>
        {account?.mentionsProfiles?.map((profile) => (
          <ProfileTab
            key={profile.id}
            profile={profile}
            session={session}
            account={account}
            onRemoving={onRemoving}
          />
        ))}
      </TabList>

      <TabPanels mb="10"
      >
        <TabPanel key={account.id} p={0}>
          <Posts profile={account} account={account} session={session}
            onSessionUpdate={onSessionUpdate}
          />
        </TabPanel>
        {account?.mentionsProfiles?.map((profile) => (
          <TabPanel key={profile.id} p={0}>
            <Posts profile={profile} account={account} session={session}
            />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  )
}

export default Profiles;